import {ReactElement} from "react";
import {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {WithTheme} from '@yosmanyga/theme'
import {NonExistentPrimitiveError, usePrimitives} from '@yosmanyga/primitive-ui-spec'

type IconProps = {
    component: ReactElement,
    size: 'xxs' | 'xs' | 'sm'
    onClick?: () => void,
}

const Icon = ({
    component,
    size,
    ...props
}: IconProps) => {
    const {Icon: BaseIcon} = usePrimitives()

    if (!BaseIcon) {
        throw new NonExistentPrimitiveError('Icon')
    }

    if (!component) {
        throw new Error('Undefined icon. Please check that the icon exists in the collection');
    }

    const width = convertSize(size)

    return <BaseIcon
        component={component}
        width={width}
        height={width}
        {...props}
    />
}

const convertSize = (size: IconProps['size']) => {
    switch (size) {
        case 'xxs':
            return 24
        case 'xs':
            return 40
        case 'sm':
            return 64
    }
}

const IconWithTheme = (props: IconProps & UnnormalizedStyleProps) => <WithTheme
    {...props}
    identifier='icon'
    Component={Icon}
/>

export default IconWithTheme
